import { Outlet, createFileRoute } from "@tanstack/react-router";

import { OfferPageChrome } from "~/components/offer-page/offer-page-chrome";

// Offer pages live outside the main marketplace chrome: they get the lighter
// `OfferPageChrome` (D logo + "vetted by" header, "Powered by" footer) so the
// landing page reads as the coach's own offer rather than a DCM site page.
export const Route = createFileRoute("/$username/offer")({
  component: OfferLayout,
});

function OfferLayout() {
  return (
    <OfferPageChrome>
      <Outlet />
    </OfferPageChrome>
  );
}
